import useMapModalStore from '../../../../stores/useMapModalStore';
import useMapViewStore from '../../../../stores/useMapViewStore';
import RealEstateInfoModal from '../../../../ui/modals/RealEstateInfoModal';
import { closeMapSelectionModal } from './closeMapSelectionModal';

/** House info modal (`activeModal === 'realEstateInfo'`). Fully store-driven close. */
export default function RealEstateInfoHost() {
  const isRealEstateInfoModalOpen = useMapModalStore((s) => s.activeModal === 'realEstateInfo');
  const selectedMapObject = useMapViewStore((s) => s.selectedMapObject);
  const setSelectedMapObject = useMapViewStore((s) => s.setSelectedMapObject);

  return (
        <RealEstateInfoModal
          isOpen={isRealEstateInfoModalOpen}
          plot={selectedMapObject}
          onClose={closeMapSelectionModal}
          onPlotUpdate={(updatedPlot) => {
            // Update selectedMapObject with new data
            setSelectedMapObject(updatedPlot);
          }}
        />
  );
}
